// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3t91Y","file":"styles_file__1xlrb"};